import { IRemoteModuleManifest } from '../types';

export function getBestPublicPath(manifest?: IRemoteModuleManifest) {
    const bestCdn =
      /cdn_domain=([^;]+)/.exec(document.cookie)?.[1] || window.scheduledCdnDomain || '';
    const url = manifest?.remoteEntry?.url || '';
    const lastIndex = url.lastIndexOf('/') + 1;
    const currentPublicPath = manifest?.publicPath || url.slice(0, lastIndex) || '';

    if (bestCdn && /^(https:)?(\/\/)?(sf|lf)/.test(currentPublicPath)) {
      const bestPublicPath = currentPublicPath.replaceAll(
        /(sf|lf).*\.com|\/obj\/[^\/]*\//g,
        match => {
          if (/(sf|lf).*\.com/.test(match)) {
            return bestCdn;
          } else if (/\/obj\/[^\/]*\//.test(match)) {
            return bestCdn.includes('larksuitecdn')
              ? '/obj/lark-static-us/'
              : '/obj/feishu-static/';
          } else {
            return match;
          }
        },
      );
      return {
        bestPublicPath,
        currentPublicPath,
      };
    }
    return {
      bestPublicPath: '',
      currentPublicPath: '',
    };
  }
